import { render, staticRenderFns } from "./job-employment-position-resource-item-1-job-position-description.vue?vue&type=template&id=5e8bf116&"
import script from "./job-employment-position-resource-item-1-job-position-description.vue?vue&type=script&lang=ts&"
export * from "./job-employment-position-resource-item-1-job-position-description.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports